import React from 'react';
export function FamilyFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-12" data-id="element-1077">
      Frequently Asked Questions
    </h2>;
}